import actionTypes from './actionTypes';
const INITIAL_STATE = {
  loading: false,
  failed: false,
  error: false,
  message: null,

  discountCodesLoading: false,
  discountCodesFailed: false,
  discountCodes: {},
  discountCodesList: [],
  discountCodesrror: false,
  discountCodesMessage: null,

  messageReceiversLoading: false,
  messageReceivers: {},
  messageReceiversList: [],
  messageReceiversFailed: false,
  messageReceiversError: false,
  messageReceiversMessage: null,

  messagesLoading: false,
  messagesFailed: false,
  messagesError: false,
  messagesMessage: null,
  messagesList: [],

  sendMessageLoading: false,
  sendMessageFailed: false,
  sendMessageError: false,
  sendMessageMessage: null,

  fetchMessageByIdLoading: false,
  fetchMessageByIdFailed: false,
  fetchMessageByIdError: false,
  fetchMessageByIdMessage: null,
  messageObject: {}
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {


    case actionTypes.FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_LOADING:
      return {
        ...state,
        discountCodesLoading: true,
        discountCodesFailed: false,
        discountCodes: {},
        discountCodesList: [],
        discountCodesrror: false,
        discountCodesMessage: null
      };

    case actionTypes.FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_SUCCESS:
      return {
        ...state,
        discountCodesMessages: null,
        discountCodes: { ...action.payload },
        discountCodesList: action.payload.discountCodes,
        discountCodesLoading: false,
        discountCodesFailed: false,
        discountCodesError: false,
      };
    case actionTypes.FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_FAILED:
      return {
        ...state,
        discountCodes: {},
        discountCodesList: [],
        discountCodesLoading: false,
        discountCodesFailed: true,
        discountCodesError: false,
        discountCodesMessage: action.payload.message
      }
    case actionTypes.FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_REJECT:
      return {
        ...state,
        discountCodesLading: false,
        discountCodes: {},
        discountCodesList: [],
        discountCodesFailed: false,
        discountCodesError: true,
        discountCodesMessage: null
      }

    case actionTypes.FETCH_MESSAGES_LOADING:
      return {
        ...state,
        loading: true,
        failed: false,
        error: false,
        message: null
      };

    case actionTypes.FETCH_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: action.payload,
        messagesList: action.payload.channelMessages,
        loading: false,
        failed: false,
        error: false,
        message: null
      };
    case actionTypes.FETCH_MESSAGES_FAILED:
      return {
        ...state,
        loading: false,
        failed: true,
        error: false,
        message: action.payload.message
      }
    case actionTypes.FETCH_MESSAGES_REJECT:
      return {
        ...state,
        loading: false,
        failed: false,
        error: true,
        message: null
      }


    case actionTypes.FETCH_MESSAGE_RECEIVERS_LOADING:
      return {
        ...state,
        messageReceiversLoading: true,
        messageReceivers: {},
        messageReceiversList: [],
        messageReceiversFailed: false,
        messageReceiversError: false,
        messageReceiversMessage: null
      };

    case actionTypes.FETCH_MESSAGE_RECEIVERS_SUCCESS:
      return {
        ...state,
        messageReceivers: { ...action.payload },
        messageReceiversList: [...action.payload.channelMessageUsers],
        messageReceiversLoading: false,
        messageReceiversFailed: false,
        messageReceiversError: false,
        messageReceiversMessage: null
      };
    case actionTypes.FETCH_MESSAGE_RECEIVERS_FAILED:
      return {
        ...state,
        messageReceiversLoading: false,
        messageReceiversFailed: true,
        messageReceivers: {},
        messageReceiversList: [],
        messageReceiversError: false,
        messageReceiversMessage: action.payload.message
      }
    case actionTypes.FETCH_MESSAGE_RECEIVERS_REJECT:
      return {
        ...state,
        messageReceivers: {},
        messageReceiversList: [],
        messageReceiversLoading: false,
        messageReceiversFailed: false,
        messageReceiversError: true,
        messageReceiversMessage: null
      }

    case actionTypes.SEND_MESSAGE_LOADING:
      return {
        ...state,
        sendMessageLoading: true,
        sendMessageFailed: false,
        sendMessageError: false,
        sendMessageMessage: null
      };

    case actionTypes.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        sendMessageLoading: false,
        sendMessageFailed: false,
        sendMessageError: false,
        sendMessageMessage: null
      };
    case actionTypes.SEND_MESSAGE_FAILED:
      return {
        ...state,
        sendMessageLoading: false,
        sendMessageFailed: true,
        sendMessageError: false,
        sendMessageMessage: action.payload.message
      }
    case actionTypes.SEND_MESSAGE_REJECT:
      return {
        ...state,
        sendMessageLoading: false,
        sendMessageFailed: false,
        sendMessageError: true,
        sendMessageMessage: null
      }


    case actionTypes.FETCH_MESSAGE_BY_ID_LOADING:
      return {
        ...state,
        fetchMessageByIdLoading: true,
        fetchMessageByIdFailed: false,
        fetchMessageByIdError: false,
        fetchMessageByIdMessage: null
      };

    case actionTypes.FETCH_MESSAGE_BY_ID_SUCCESS:
      return {
        ...state,
        fetchMessageByIdLoading: false,
        fetchMessageByIdFailed: false,
        fetchMessageByIdError: false,
        fetchMessageByIdMessage: null,
        messageObject: action.payload.channelMessage
      };
    case actionTypes.FETCH_MESSAGE_BY_ID_FAILED:
      return {
        ...state,
        fetchMessageByIdLoading: false,
        fetchMessageByIdFailed: true,
        fetchMessageByIdError: false,
        fetchMessageByIdMessage: action.payload.message
      }
    case actionTypes.FETCH_MESSAGE_BY_ID_REJECT:
      return {
        ...state,
        fetchMessageByIdLoading: false,
        fetchMessageByIdFailed: false,
        fetchMessageByIdError: true,
        fetchMessageByIdMessage: null
      }

    case actionTypes.EMPTY_MESSAGE_OBJECT:
      return {
        ...state,
        fetchMessageByIdLoading: false,
        fetchMessageByIdFailed: false,
        fetchMessageByIdError: false,
        fetchMessageByIdMessage: null,
        messageObject: {}
      }

    default:
      return state;
  }
};